import 'whatwg-fetch';
import 'slick-carousel';
import 'superfish';
import 'jquery-accessible-subnav-dropdown';
import './components/accessible-menu';
import './components/mobile-nav';
import 'electro-privacy';

// /////////////////////////////////////////////////////////////////////////////
// Routes
// /////////////////////////////////////////////////////////////////////////////

jQuery(document).ready(() => {
    /* activate mobile nav */
    $('.nav-toggle').click((e) => {
        $('#mobile-nav').toggleClass('active');
        e.preventDefault();
    });

    /* mobile sub-menu toggle */
    $('.expand-toggle').click((e) => {
        const $el = $(e.currentTarget);
        $el.parent('.menu-item').toggleClass('active');
        e.preventDefault();
    });

    /* activate sliders */
    $('.slider-single-product').slick({
        infinite: true,
        adaptiveHeight: true,
        prevArrow: '<div class="prev hidden-phone"></div>',
        nextArrow: '<div class="next hidden-phone"></div>',
        dots: true,
    });

    /* --------------------< superfish >--------------------*/
    jQuery('#primary-nav ul').superfish({
        delay: 200,
        animation: { opacity: 'show', height: 'show' },
        speed: 'fast',
        autoArrows: false,
        dropShadows: false,
    });
    /* --------------------< /superfish >--------------------*/

    /* --------------------< Superscript on registration marks >--------------------*/

    const $html = jQuery('main').html();
    jQuery('main').html(
        $html
            .replace(/409&reg;/gi, '409<sup>&reg;</sup>')
            .replace(/409®/gi, '409<sup>&reg;</sup>')
            .replace(/Stainblock®/gi, 'Stainblock<sup>&reg;</sup>')
    );

    /* --------------------< /Superscript on registration marks >--------------------*/

    // OneTrust
    document.getElementById('do-not-share').addEventListener('click', () => {
        if (typeof OneTrust !== 'undefined') {
            OneTrust.ToggleInfoDisplay();
        }
    });

    // Quiq chat init
    const quiqChatButton = document.getElementById('quiq-chat-button');

    if (quiqChatButton) {
        const interval = setInterval(() => {
            if (typeof OptanonActiveGroups === 'undefined') return;
            clearInterval(interval);

            if (OptanonActiveGroups.indexOf('C0003') > -1) {
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.src = 'https://clorox.quiq-api.com/app/chat-ui/index.js';
                document.head.appendChild(scriptElement);
                const interval2 = setInterval(() => {
                    if (typeof Quiq === 'undefined') return;
                    clearInterval(interval2);

                    const chat = Quiq({ pageConfigurationId: '409' });
                }, 100);
            } else {
                const chatConsentMessage = document.createElement('div');
                chatConsentMessage.classList.add('consent-message');
                chatConsentMessage.innerHTML =
                    'Please enable <a href="#" class="ot-sdk-show-settings">cookies</a> to chat.';
                quiqChatButton.parentElement.appendChild(chatConsentMessage);
                quiqChatButton.remove();
            }
        }, 100);
    }
});
